import { render, staticRenderFns } from "./reportProblemForm.vue?vue&type=template&id=521c5d70&scoped=true"
import script from "./reportProblemForm.vue?vue&type=script&lang=js"
export * from "./reportProblemForm.vue?vue&type=script&lang=js"
import style0 from "./reportProblemForm.vue?vue&type=style&index=0&id=521c5d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c5d70",
  null
  
)

export default component.exports